import { type FC } from 'react'

import { type ITextObject } from 'types/interfaces/ITextObject'

import CaptionTextOverlay from '../PhotoEdit/CaptionTextOverlay/CaptionTextOverlay'

const ImagePreview: FC<{ src: string; textObject?: ITextObject }> = ({
    src,
    textObject
}) => {
    return (
        <>
            <div className='swiper-zoom-container'>
                <img className='preview__file__image' src={src} alt='Preview' 
onLoad={() => {
  const isBlob = src.startsWith('blob:')
  const entries = performance.getEntriesByName(src)
  const last = entries[entries.length - 1] as PerformanceResourceTiming | undefined

  if (isBlob) {
    console.log('[ImagePerf] LOADED_BLOB', {
      src,
      entriesLen: entries.length,
    })
    return
  }

  if (!last || last.entryType !== 'resource') {
    console.log('[ImagePerf] LOADED_NO_TIMING', {
      src,
      entriesLen: entries.length,
      note: 'No PerformanceResourceTiming (likely TAO/CORS or timing not available yet)',
    })
    // return
  }

/*   console.log('[ImagePerf] LOADED_URL', {
    src,
    initiatorType: last.initiatorType,
    transferSize: last.transferSize,         // 0 often cache (if TAO allows)
    encodedBodySize: last.encodedBodySize,
    decodedBodySize: last.decodedBodySize,
    duration: last.duration,
    startTime: last.startTime,
    responseStart: last.responseStart,
  }) */
}} />
            </div>
            <CaptionTextOverlay
                text={textObject?.value}
                xPercent={textObject?.x}
                yPercent={textObject?.y}
                zIndex={5}
            />
        </>
    )
}

export default ImagePreview
